module.exports = __webpack_public_path__ + "img/958cba4.jpg";